import http from "@/http-common";

/* eslint-disable */
class SendEmailService {
  sendEmail(data: any): Promise<any> {
    return http.api.post("/sendEmail/", data);
  }

  sendResetEmail(data: any): Promise<any> {
    return http.api.post("/sendResetEmail/", data);
  }

  sendEmailByMenu(data: any): Promise<any> {
    return http.api.post("/sendEmailByMenu/", data);
  }

}

export default new SendEmailService();
